import { useCallback } from 'react';
import { useSelector, useStore, shallowEqual } from 'react-redux';
import useAsync from './useAsync';
import queryGetCredoPreferences from '../data/queryCredoPreferences';
import getCredoPreferences from '../requests/getCredoPreferences';
const useQueryGetCredoPreferences = function () {
  let {
    types,
    fallbackValue,
    forceFetch = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let {
    defer = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const store = useStore();
  const useAsyncFn = useCallback(() => {
    const {
      promise
    } = queryGetCredoPreferences({
      store,
      types,
      fallbackValue
    });
    return promise;
  }, [store, types, fallbackValue]);
  const result = useSelector(state => getCredoPreferences(state, types), shallowEqual);
  return useAsync(useAsyncFn, [forceFetch ? Math.random() : null, defer], {
    forceFetch,
    defaults: {
      data: result,
      loading: true
    },
    defer
  });
};
export default useQueryGetCredoPreferences;